import { useParameter } from '../../../shared';

export function useDescription() {
  const description = [
    'Showing the long-term view of the crop commodity price development in absolute values or based on a price Index ',
    'Source: ICE, NYSE, USDA (Commodity Prices)'
  ];
  return description;
}